import { resolvePayloadTemplate } from '@agent-maurice/viewer-core'

export interface ResolvedMiniAppAction {
  eventId: string
  payload: Record<string, unknown> | undefined
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

// resolveMiniAppAction maps a rendered action (OpenUI actionId, tree
// on_click) to the runtime event it triggers, through the instance
// action_bindings: the bound event_id wins over the action id, and a
// non-empty payload_template is resolved against the action payload
// ({{action.<key>}}). Shared by Run (useMiniAppRuntime) and the Studio
// previews so the three surfaces send the same event.
export function resolveMiniAppAction(
  actionBindings: Readonly<Record<string, unknown>> | null | undefined,
  actionId: string,
  payload?: Record<string, unknown>,
): ResolvedMiniAppAction {
  const binding = actionBindings?.[actionId]
  if (!isRecord(binding)) return { eventId: actionId, payload }
  const eventId =
    typeof binding.event_id === 'string' && binding.event_id.trim()
      ? binding.event_id
      : actionId
  const template = binding.payload_template
  if (isRecord(template) && Object.keys(template).length > 0) {
    return {
      eventId,
      payload: resolvePayloadTemplate(template, payload ?? {}) as Record<string, unknown>,
    }
  }
  return { eventId, payload }
}
